import { Alert, Button, Grid2, Typography, Stack, useTheme } from '@mui/material';
import LinearProgress from '@mui/material/LinearProgress';
import fileCheck from '../../assets/icons/file-check-02.svg';
import { TitledSection } from '../../layout/TitledSection';
import { FormProgressButton } from '@enroller/admissions-components';
import { useNavigate } from 'react-router-dom';

export interface ApplicationProgressSectionProps {
  progress: number;
  formProgressButtons: { label: string; route: string; progress: number }[];
  completeApplicationButtonLabel: string;
  onClickCompleteApplication: () => void;
  alertMessage?: string;
  estimatedTime: string;
  title: string;
}

export const ApplicationProgressSection = ({
  progress,
  estimatedTime,
  alertMessage,
  completeApplicationButtonLabel,
  onClickCompleteApplication,
  formProgressButtons,
  title,
}: ApplicationProgressSectionProps) => {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <TitledSection icon={fileCheck} title={title}>
      {alertMessage ? (
        <Grid2>
          <Alert sx={{ alignItems: 'flex-start' }} variant="outlined" severity="info">
            {alertMessage}
          </Alert>
        </Grid2>
      ) : null}

      {progress > 0 && progress < 100 ? (
        <Grid2 size={12}>
          <LinearProgress value={progress} variant="determinate" />
        </Grid2>
      ) : null}

      <Grid2 size={12} justifyContent="space-between" container alignItems="center">
        <Grid2 size="grow" container spacing={{ xs: 4, md: 4 }}>
          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body2">Percentage Complete:</Typography>
            <Typography color={theme.palette.primary.light}>{progress}%</Typography>
          </Stack>

          <Stack direction="row" alignItems="center" gap={1}>
            <Typography variant="body2">Estimated time to finish:</Typography>
            <Typography color={theme.palette.warning.main}>{estimatedTime}</Typography>
          </Stack>
        </Grid2>

        <Button onClick={onClickCompleteApplication} variant="outlined" color="primary">
          {completeApplicationButtonLabel}
        </Button>
      </Grid2>

      {formProgressButtons && formProgressButtons.length ? (
        <>
          <Grid2 size={12}>
            <Typography variant="body2">The following sections in your application still need to be completed:</Typography>
          </Grid2>
          <Grid2 size={12} container spacing={{ xs: 1, md: 1 }}>
            {formProgressButtons.map((data) => (
              <FormProgressButton key={data.route} formName={data.label} onClick={() => navigate(data.route)} progress={data.progress} />
            ))}
          </Grid2>
        </>
      ) : null}
    </TitledSection>
  );
};
